/*
 * External dependencies
 */
import noUiSlider from 'nouislider';

import './style.scss';

// Price Formatte - Number into K M B T formatte
const formatCash = (n) => {
	if (n < 1e3) return n;
	if (n >= 1e3 && n < 1e6) return +(n / 1e3).toFixed(1) + 'K';
	if (n >= 1e6 && n < 1e9) return +(n / 1e6).toFixed(1) + 'M';
	if (n >= 1e9 && n < 1e12) return +(n / 1e9).toFixed(1) + 'B';
	if (n >= 1e12) return +(n / 1e12).toFixed(1) + 'T';
};

const rangeSliderWidget = document.querySelectorAll('.range-slider');

const _loop2 = function _loop2(i) {
	const rangeSlider = rangeSliderWidget[i].querySelector('.range-slider-ui'),
		valueMinInput = rangeSliderWidget[i].querySelector(
			'.range-slider-value-min'
		),
		valueMaxInput = rangeSliderWidget[i].querySelector(
			'.range-slider-value-max'
		);
	const options = {
		dataStartMin: parseInt(rangeSliderWidget[i].dataset.startMin, 10),
		dataStartMax: parseInt(rangeSliderWidget[i].dataset.startMax, 10),
		dataMin: parseInt(rangeSliderWidget[i].dataset.min, 10),
		dataMax: parseInt(rangeSliderWidget[i].dataset.max, 10),
		dataStep: parseInt(rangeSliderWidget[i].dataset.step, 10),
	};
	const start = options.dataStartMax
			? [options.dataStartMin, options.dataStartMax]
			: [options.dataStartMin],
		connect = options.dataStartMax ? true : 'lower';
	noUiSlider.create(rangeSlider, {
		start,
		connect,
		step: options.dataStep,
		tooltips: {
			to: function to(value) {
				return '$' + formatCash(value);
			},
			from: function from(value) {
				return Number(value);
			},
		},
		range: {
			min: options.dataMin,
			max: options.dataMax,
		},
		format: {
			to: function to(value) {
				return '$' + parseInt(value, 10);
			},
			from: function from(value) {
				return Number(value);
			},
		},
	});
	rangeSlider.noUiSlider.on('update', function (values, handle) {
		let value = values[handle];
		value = value.replace(/\D/g, '');

		if (handle) {
			if (valueMaxInput) {
				valueMaxInput.value = Math.round(value);
			}
		} else if (valueMinInput) {
			valueMinInput.value = Math.round(value);
		}
	});
	rangeSlider.noUiSlider.on('change', function (values, handle) {
		const priceRangeInput = document.querySelector('.price-input');
		const InputChangeEvent = new Event('change');
		priceRangeInput.dispatchEvent(InputChangeEvent);
	});

	if (valueMinInput) {
		valueMinInput.addEventListener('change', function () {
			rangeSlider.noUiSlider.set([this.value, null]);
		});
	}

	if (valueMaxInput) {
		valueMaxInput.addEventListener('change', function () {
			rangeSlider.noUiSlider.set([null, this.value]);
		});
	}

	const resetListingFilter = document.querySelector('.reset-listing-filter');
	if (resetListingFilter) {
		resetListingFilter.addEventListener('click', () => {
			rangeSlider.noUiSlider.reset();
		});
	}
};

for (let i = 0; i < rangeSliderWidget.length; i++) {
	_loop2(i);
}
